import { Component, OnInit, effect, inject } from '@angular/core';
import { CentroLogisticoCementoApiService } from '../../../services/centro-logistico-cemento-api.service';
import { CentrosLogisticosCementoStore } from '../../../stores/centros-logisticos-cemento.store';
import { CentrosLogisticosCementoUiEffectsService } from '../ui-effects/centros-logisticos-cemento-ui-effects.service';

@Component({
  selector: 'app-centros-logisticos-cemento-page',
  templateUrl: './centros-logisticos-cemento-page.component.html',
  styleUrls: ['./centros-logisticos-cemento-page.component.css'],
  providers: [
    CentroLogisticoCementoApiService,
    CentrosLogisticosCementoStore,
    CentrosLogisticosCementoUiEffectsService,
  ],
})
export class CentrosLogisticosCementoPageComponent implements OnInit {
  readonly store = inject(CentrosLogisticosCementoStore);
  private readonly uiEffects = inject(CentrosLogisticosCementoUiEffectsService);

  constructor() {
    effect(() => {
      this.uiEffects.syncLoading(this.store.loading());
    });
  }

  ngOnInit(): void {
    this.store.loadItems().subscribe({
      error: () => {
        this.uiEffects.showLoadError();
      },
    });
  }
}
